import React from 'react';
import PreferencesWrapper from './PreferencesWrapper';

const NotificationPreferencesWrapper = (routerProps) => (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <PreferencesWrapper {...routerProps} />
);

export default NotificationPreferencesWrapper;
